<template>
  <div class="lds-ring" :style="`--loading-width: ${width}px`">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "loading",
  props: {
    width: {type: Number, default: 80},
  }
};
</script>

<style>
.lds-ring {
  display: inline-block;
  position: relative;
  width: var(--loading-width);
  height: var(--loading-width);
  transform: scale(0.5);
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: calc(var(--loading-width) - 15px);
  height: calc(var(--loading-width) - 15px);
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring.accents div {
  border: 8px solid var(--v-primary-base);
  border-color: var(--v-primary-base) transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
